<template src="./paladin-meta-properties.html"></template>

<script>
import Vue from 'vue'
import { ChiRhosNext } from '@paladin/core'

// import { PaladinLimit, PaladinPersonLookup } from '@paladin/core-components'

import _ from 'lodash'

export default {
  components: { },
  props: {
    preset: {
      type: Object,
      required: false,
      default: null,
    },
    properties:
    {
      type: Object,
      required: false,
      default: null,
    }
  },
  data() {
    return {
      payload: [],
    }
  },
  computed: {
  },
  watch: {
    preset: function() {
      this.init()
    },
  },
   created: function() {
  },
  mounted() {
    this.$nextTick(function() {
      this.init()
    })
  },
  methods: {
    init() {

      if(this.preset)
      {
        let preset = this.preset
        let payload = this.payload
        let properties = this.properties
        let generateUUID = this.generateUUID

        Object.keys(preset).forEach(function(key) {
          Vue.set(preset[key], 'id', generateUUID())
          Vue.set(preset[key], 'key', key)
          Vue.set(preset[key], 'value', properties && properties[key] ? properties[key] : null)
          payload.push(preset[key])
      });
      }
    },
    generateUUID() { // Public Domain/MIT https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
      var d = new Date().getTime()// Timestamp
      var d2 = (performance && performance.now && (performance.now()*1000)) || 0// Time in microseconds since page-load or 0 if unsupported
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = Math.random() * 16// random number between 0 and 16
          if(d > 0){// Use timestamp until depleted
              r = (d + r)%16 | 0
              d = Math.floor(d/16)
          } else {// Use microseconds since page-load if supported
              r = (d2 + r)%16 | 0
              d2 = Math.floor(d2/16)
          }
          return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
      });
    },
    setValue(key, value)
    {
      this.$emit('set', { key: key, value: value ? value : null})
    },
    // getOptions(options)
    // {
    //   return options.map(function(option) { return { value: option }  })
    // },
  },
}
</script>

<style lang="scss"></style>
